import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { TabExpertiseComponent } from './tab-expertise/tab-expertise.component';

const routes: Routes = [
  {
    path: 'raw-data-access',
    loadChildren: () =>
      import('./raw-data-access/raw-data-access.module').then(
        (m) => m.RawDataAccessModule
      ),
  },
  {path : 'tab-expertise', component: TabExpertiseComponent}
];

@NgModule({
  imports: [
    RouterModule.forRoot(
      routes,
    { useHash: true, initialNavigation: 'disabled' }
  )],
  exports: [RouterModule],
})
export class AppRoutingModule {}
